import IconTile from "@/components/common/iconTile/iconTile.component";
import RingBulletItem from "@/components/common/ringBulletItem/ringBulletItem.component";
import type { LucideIcon } from "lucide-react";
import LinkedText from "../linkedText/linkedText.component";

export interface SubTopic {
  // Anchor id, so CardGrid "Explore" links can jump to the row.
  id?: string;
  icon: LucideIcon;
  title: string;
  // Supports `[label](/route)` links and `**bold**` (see LinkedText).
  text: string;
  // Small red label above the list, e.g. "What this can look like".
  label: string;
  items: string[];
}

interface SubTopicsProps {
  topics: SubTopic[];
}

// Ruled rows, one per sub-topic: icon tile, title and text on the left, a
// labelled ring-bullet list on the right (the preview's `.subt`). The first
// row gets the heavy ink rule.
const SubTopics = ({ topics }: SubTopicsProps) => (
  <div>
    {topics.map((topic) => (
      <div
        key={topic.title}
        id={topic.id}
        className="grid scroll-mt-[88px] items-start gap-7 border-t border-line py-10 first:border-t-2 first:border-ink lg:grid-cols-2 lg:gap-12"
      >
        <div>
          <div className="mb-2.5 flex items-center gap-3.5">
            <IconTile icon={topic.icon} index={0} size="md" />
            <h3 className="text-[1.2rem] leading-snug font-bold tracking-[-0.01em]">
              {topic.title}
            </h3>
          </div>
          <p className="text-[17px] leading-relaxed text-ink-muted">
            <LinkedText text={topic.text} />
          </p>
        </div>
        <div>
          <p className="mb-2.5 text-[13px] font-semibold text-primary">
            {topic.label}
          </p>
          <ul className="grid gap-2.5">
            {topic.items.map((item) => (
              <RingBulletItem
                key={item}
                className="text-[15.5px] leading-normal"
              >
                {item}
              </RingBulletItem>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>
);

export default SubTopics;
